import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { homeFor } from "@/lib/constants";

export const ProtectedRoute = ({ children, admin = false, role, allowIncomplete = false }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-[60vh] items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#0F2D5E]" />
      </div>
    );
  if (!user) return <Navigate to="/accedi" replace />;
  if (admin && user.role !== "admin") return <Navigate to={homeFor(user)} replace />;
  if (role && user.role !== role && !(role === "user" && user.role === "admin")) return <Navigate to={homeFor(user)} replace />;
  if (!allowIncomplete && user.role === "user" && user.profile_completed === false) return <Navigate to="/completa-profilo" replace />;
  return children;
};
